



































import { computed, defineComponent, ref, watch } from '@vue/composition-api'
import { VPagination, VTextField, VBtn } from 'vuetify/lib'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-pagination',
  components: {
    VPagination,
    VTextField,
    VBtn
  },
  props: {
    total: { type: Number, required: true },
    totalPerPage: { type: Number, required: true },
    page: { type: Number, required: true },
    length: { type: Number, required: true },
    totalVisible: { type: Number, default: 7 },
    hidePageJump: { type: Boolean, default: false }

  },
  setup (props) {
    const pageJump = ref(props.page)

    const isValidPage = computed(() => {
      const jumpNumber = Number(pageJump.value)
      return jumpNumber >= 1 && jumpNumber <= props.length
    })

    const isInPageRange = () => {
      const jumpNumber = Number(pageJump.value)
      return (jumpNumber >= 1 && jumpNumber <= props.length) ? true : 'Please enter a valid page'
    }
    watch(() => props.page, (newValue) => {
      pageJump.value = newValue
    })

    return {
      pageJump,
      isValidPage,
      isInPageRange
    }
  }
})
